import { render } from "./App.vue?vue&type=template&id=50c595e9"
const script = {}

import "./App.vue?vue&type=style&index=0&id=50c595e9&lang=css"

import exportComponent from "/Users/sung-a/.jenkins/workspace/Sunga/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__